import React, { useEffect } from "react";
import MobileMenuSearch from "./sub-components/MobileSearch";
import MobileNavMenu from "./sub-components/MobileNavMenu";
import { usePartner } from "../../helpers/BrandPageAPI";

const MobileMenu = ({ categoryData, collectionData }) => {
  const { partnerData } = usePartner();
  const cartLogoColor = partnerData?.StoreColor;

  useEffect(() => {
    const offCanvasNav = document.querySelector("#offcanvas-navigation");
    const anchorLinks = offCanvasNav.querySelectorAll("a.is_link");

    for (let i = 0; i < anchorLinks.length; i++) {
      anchorLinks[i].addEventListener("click", () => {
        closeMobileMenu();
      });
    }
  });

  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.remove("active");
    document.body.style.overflow = "";
  };

  return (
    <div className="offcanvas-mobile-menu" id="offcanvas-mobile-menu">
      <button
        className="offcanvas-menu-close"
        id="mobile-menu-close-trigger"
        onClick={() => closeMobileMenu()}
        style={{ background: cartLogoColor }}
      >
        <i className="pe-7s-close"></i>
      </button>
      <div className="offcanvas-wrapper">
        <div className="offcanvas-inner-content">
          {/* mobile search */}
          <MobileMenuSearch />

          {/* mobile nav menu */}
          <MobileNavMenu
            categoryData={categoryData}
            collectionData={collectionData}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
